import createPlugin from './createPlugin';
import FormHtmlRenderer from './Renderer/FormHtmlRenderer';
import { lazyLoad } from '@react-page/editor';
const FormDefaultControls = lazyLoad(() => import('./Controls/Controls'));
import { FormController } from './Controls/FormController';
export default (settings) => {
    const plugin = createPlugin(Object.assign({ Controls: FormDefaultControls, Renderer: FormHtmlRenderer }, settings));
    return plugin;
};
export { FormController };
//# sourceMappingURL=index.js.map